import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { useContext } from 'react';
import { ThemeColorMode } from 'src/common/enums';
import CertificationBadgeIcon from 'src/images/svgs/certifications/certification-badge.svg';
import PathLogoIcon from 'src/images/svgs/certifications/path-logo.svg';
import EchoLogoIcon from 'src/images/svgs/echo-icon.svg';
import SocSimLogoIcon from 'src/images/svgs/soc-sim/soc-sim-icon.svg';
import ThSimLogoIcon from 'src/images/svgs/threat-hunting/th-logo.svg';
import { StyledIconLogo } from './custom-navbar-icon.styles';
import { CustomNavbarIconTypes } from './custom-navbar-icon.types';
const navTypeMap = {
  [CustomNavbarIconTypes.CERTIFICATION]: {
    icon: CertificationBadgeIcon,
    alt: 'certification logo',
    width: '2rem',
    height: '2.5rem',
    margin: '0 0.5rem 0 0.1rem',
    marginMd: '0 0.5rem 0 0'
  },
  [CustomNavbarIconTypes.SOC_SIM]: {
    icon: SocSimLogoIcon,
    alt: 'soc simulator logo',
    width: '2.5rem',
    height: '3rem',
    marginMd: '0 -0.5rem 0 0'
  },
  [CustomNavbarIconTypes.TH_SIM]: {
    icon: ThSimLogoIcon,
    alt: 'threat hunting simulator logo',
    width: '2.3rem',
    height: '3rem',
    margin: '0 0.8rem 0 0'
  },
  [CustomNavbarIconTypes.PATH]: {
    icon: PathLogoIcon,
    alt: 'Paths logo',
    width: '2rem',
    height: '2.5rem',
    margin: '0 0.6rem 0 0.1rem',
    marginMd: '0 0.5rem 0 0'
  },
  [CustomNavbarIconTypes.ECHO]: {
    icon: EchoLogoIcon,
    alt: 'Echo logo',
    width: '2rem',
    height: '2.5rem'
  }
};
const pathStartWith = ['/soc-sim', '/ttx', '/threat-hunting-sim'];
const pathMatchingSAL1 = new Set(['/certification/security-analyst-level-1']);
const pathMatchingPT1 = new Set(['/certification/junior-penetration-tester']);
export const CustomNavbarIcon = ({
  type,
  forcedTheme
}: {
  type: CustomNavbarIconTypes;
  forcedTheme?: ThemeColorMode;
}) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkModeTheme = theme === ThemeColorMode.DARK;
  const {
    icon,
    ...rest
  } = navTypeMap[type];
  const isDarkMode = pathStartWith.some(path => !!window.location.pathname.includes(path)) || pathMatchingSAL1.has(window.location.pathname) || pathMatchingPT1.has(window.location.pathname) || isDarkModeTheme || forcedTheme === ThemeColorMode.DARK;
  return <StyledIconLogo isDark={isDarkMode} src={icon} {...rest} data-sentry-element="StyledIconLogo" data-sentry-component="CustomNavbarIcon" data-sentry-source-file="custom-navbar-icon.tsx" />;
};